/* eslint-disable react/no-danger */
/* eslint-disable jam3/no-sanitizer-with-danger */
import React, { ReactElement } from 'react';

import {
  ArrowForwardIosIcon,
  Heading,
  MenuIcon,
  DocumentsIcon,
  HelpOutlineIcon,
  Paragraph,
  ArrowBackIosIcon,
} from 'elmo-elements';

import { sanitizeHTML } from '@/lib/util';

interface GeneralPropsType {
  isVisible: boolean;
  content: string;
  classNamePrefix: string;
}

const General = ({
  isVisible,
  content,
  classNamePrefix,
}: GeneralPropsType): ReactElement => {
  const generalContent = sanitizeHTML(content) as unknown as string;

  return (
    <div
      className={`${classNamePrefix}__general__wrapper ${
        isVisible ? 'is-visible' : ''
      }`}
    >
      <div className={`${classNamePrefix}__general`}>
        <div
          dangerouslySetInnerHTML={{
            __html: generalContent,
          }}
        />
      </div>
      <div
        className={`${classNamePrefix}__tip-wrapper ${classNamePrefix}__tip--menu`}
      >
        <div className={`${classNamePrefix}__tip-heading`}>
          <Heading className="px-3 py-1">Menu Tips</Heading>
        </div>
        <div className={`${classNamePrefix}__tip-content px-3`}>
          <ul>
            <li>
              <MenuIcon /> Quick find index
            </li>
            <li>
              <DocumentsIcon /> Course asset library
            </li>
            <li>
              <HelpOutlineIcon /> Module Help
            </li>
          </ul>
        </div>
      </div>
      <div
        className={`${classNamePrefix}__tip-wrapper ${classNamePrefix}__tip--audio`}
      >
        <div className={`${classNamePrefix}__tip-heading`}>
          <Heading className="px-3 py-1">Audio Tips</Heading>
        </div>
        <div className={`${classNamePrefix}__tip-content px-3`}>
          <ul>
            <li>Activate voice-overs</li>
            <li>Pause voice-overs</li>
          </ul>
        </div>
      </div>
      <div
        className={`${classNamePrefix}__tip-wrapper ${classNamePrefix}__tip--navigation`}
      >
        <div className={`${classNamePrefix}__tip-heading`}>
          <Heading className="px-3 py-1">Navigation Tips </Heading>
        </div>
        <div className={`${classNamePrefix}__tip-content px-3`}>
          <ul>
            <li>
              <ArrowBackIosIcon /> Previous frame
            </li>
            <li>
              <ArrowForwardIosIcon /> Next frame
            </li>
            <li className="align-center">
              <Paragraph align="center">
                Course progress <br />
                <i>'Current frame'</i> <br />
                of <i>'Total frames'</i>
              </Paragraph>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default General;
